import React from 'react';
import { Card } from '../ui/card';
import { Target } from 'lucide-react';

const KPIEmptyState = ({ message = "No hay KPIs disponibles" }) => {
  return (
    <Card className="py-12">
      <div className="text-center">
        <Target className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-medium">{message}</p>
      </div>
    </Card>
  );
};

export default KPIEmptyState;
